<template>
  <v-container id="calendar-in-batch">
    <app-city-header :payload="payload"> </app-city-header>

    <v-row>
      <v-col sm="3">
        <app-group-solution-combobox :filter="payload" @onChange="getMembers">
        </app-group-solution-combobox>
      </v-col>

      <v-col sm="3">
        <v-text-field
          label="Quantidade de Eventos"
          name="quantidadeEventos"
          type="number"
          required
          v-model="payload.quantidadeEventos"
        ></v-text-field>
      </v-col>

      <v-col>
        <v-btn color="info" outlined text @click="gerarEventos()"
          >Gerar Eventos</v-btn
        >
      </v-col>

      <v-col>
        <v-btn color="info" outlined text @click="save()" v-if="eventos.length"
          >Salvar Eventos</v-btn
        >
      </v-col>
    </v-row>

    <v-row v-if="exibirTarefas">
      <v-col>
        <v-combobox
          v-model="tarefasSelecionadas"
          :items="tarefas"
          clearable
          :label="`${isAT ? 'Atividades' : 'Tarefas'} Disponíveis`"
          item-text="nome"
          item-value="municipioTarefaId"
          multiple
        >
        </v-combobox>
      </v-col>
    </v-row>

    <v-row v-if="exibirTarefas">
      <v-col>
        <p>{{ isAT ? "Atividades" : "Tarefas" }} Selecionadas</p>
      </v-col>
    </v-row>

    <v-row v-if="exibirTarefas">
      <draggable
        :list="tarefasSelecionadas"
        group="people"
        @change="changeTarefasSelecionadas()"
      >
        <v-row>
          <v-col
            v-for="tarefa in tarefasSelecionadas"
            :key="tarefa.municipioTarefaId"
            class="draggable"
          >
            <v-card class="mx-auto">
              <v-card-text>
                {{ tarefa.nome }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </draggable>
    </v-row>

    <v-row>
      <v-col sm="3" v-for="evento in eventos" :key="evento.index">
        <v-card class="mx-auto">
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="evento.solucoesEvento[0].nome"
                  label="Grupo"
                  disabled
                  color="text-input-black"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field
                  v-model="evento.inicioString"
                  v-mask="'##/##/#### ##:##'"
                  label="Data de Início"
                  placeholder="00/00/0000 00:00"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field
                  v-model="evento.fimString"
                  v-mask="'##/##/#### ##:##'"
                  label="Data de Término"
                  placeholder="00/00/0000 00:00"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row
              v-if="
                evento.solucoesEvento.length > 0 &&
                evento.solucoesEvento[0].monitoramento === 2
              "
            >
              <v-col>
                <v-radio-group
                  v-model="evento.solucoesEvento[0].tipoMonitoramentoEvento"
                  :id="'monitoramento' + evento.index"
                >
                  <v-radio label="Trabalho de Escritório" value="1"></v-radio>
                  <v-radio label="Visita" value="2"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col>{{ isAT ? "Atividades" : "Tarefas" }} Do Evento</v-col>
            </v-row>

            <v-row>
              <v-col>
                <draggable
                  class="list-group"
                  :list="evento.tarefasEvento"
                  group="people"
                >
                  <div
                    class="list-group-item draggable"
                    v-for="tarefa in evento.tarefasEvento"
                    :key="tarefa.municipioTarefaId"
                  >
                    {{ tarefa.nome }}
                  </div>
                </draggable>
              </v-col>
            </v-row>

            <v-row v-if="!evento.showObs">
              <v-col>
                <v-btn color="info" outlined text @click="showObs(evento)"
                  >Inserir Observações</v-btn
                >
              </v-col>
            </v-row>

            <v-row v-if="evento.showObs">
              <v-col>
                <v-textarea
                  label="Observações"
                  v-model="evento.observacoes"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  cityAPI,
  AppCityHeader,
  AppGroupSolutionCombobox,
} from "@/modules/city";
import { meetingAPI } from "@/modules/calendar";
import { memberAPI } from "@/modules/city/components/MemberAPI";
import { cityTaskAPI } from "@/modules/city/API/CityTaskAPI";
import { mapActions, mapGetters } from "vuex";
import draggable from "vuedraggable";

export default {
  components: {
    AppCityHeader,
    AppGroupSolutionCombobox,
    draggable,
  },
  data() {
    return {
      payload: {
        grupoId: 0,
        municipioId: this.$route.params.id,
        solucoesEvento: [{ nome: "" }],
        tarefasEvento: [],
        convidadosEvento: [],
        quantidadeEventos: 0,
      },
      eixos: [],
      tarefas: [],
      todasAsTarefas: [],
      membros: [],
      municipio: {},
      estado: this.$store.state.uf,
      eventos: [],
      exibirTarefas: false,
      tarefasSelecionadas: [],
      datasEventos: [],
    };
  },
  computed: {
    ...mapGetters(["isAT"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    getTasks() {
      this.setLoading(true);
      cityTaskAPI
        .getTasks(
          this.payload.solucoesEvento.map(function (item) {
            return item.municipioSolucaoId;
          })
        )
        .then((resp) => {
          this.tarefas = resp.data;
          this.todasAsTarefas = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao obter ${this.isAT ? "atividades" : "tarefas"}`
          );
        });
    },
    getMembers(grupo) {
      this.setLoading(true);
      memberAPI
        .getMembersByCity(this.payload.municipioId)
        .then((resp) => {
          this.membros = resp.data;
          this.removeSolucao();
          this.getMembersByGroup();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter membros");
        });
    },
    getMembersByGroup() {
      memberAPI
        .getMembers(this.payload.grupoId)
        .then((resp) => {
          this.payload.convidadosEvento = resp.data;
          this.payload.grupoId = this.payload.grupo.grupoId;
          this.getName();
          this.getTasks();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter membros");
        });
    },
    getName() {
      meetingAPI
        .getName(this.payload)
        .then((resp) => {
          this.payload.nome = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter Nome do Evento");
        });
    },
    removeSolucao() {
      this.payload.solucoesEvento.splice(
        this.payload.solucoesEvento.indexOf(
          this.payload.grupo.municipioSolucao
        ),
        1
      );
      this.payload.solucoesEvento = [...this.payload.solucoesEvento];
      this.tarefas = [];
      this.todasAsTarefas = [];
      this.chipsTarefas = [];
      this.payload.solucoesEvento.push(this.payload.grupo.municipioSolucao);
    },
    save() {
      if (this.eventosValidos()) {
        this.setLoading(true);
        meetingAPI
          .createInBatch(this.eventos)
          .then((resp) => {
            this.eventos = [];
            this.setLoading(false);
            this.$notification.success(
              `${isAT ? "Agendas salvas" : "Encontros salvos"}  com sucesso`
            );
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error(
              `Erro ao cadastrar ${isAT ? "agendas" : "encontros"}`
            );
          });
      }
    },
    loadCity() {
      this.setLoading(true);
      cityAPI
        .get(this.$route.params.id)
        .then((resp) => {
          this.municipio = resp.data;
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
    gerarEventos() {
      this.eventos = [];
      this.exibirTarefas = true;

      for (let count = 0; count < this.payload.quantidadeEventos; count++) {
        let evento = {};
        evento.convidadosEvento = this.payload.convidadosEvento;
        evento.solucoesEvento = this.payload.solucoesEvento;
        evento.grupo = this.payload.grupo;
        evento.grupoId = this.payload.grupoId;
        evento.municipioId = this.payload.municipioId;
        evento.index = count;
        evento.tarefasEvento = [];
        evento.inserirObservacao = false;
        this.eventos.push(evento);
      }

      this.gerarNomesEventos();
    },
    gerarNomesEventos() {
      this.setLoading(true);
      meetingAPI
        .getNames(this.eventos)
        .then((resp) => {
          this.eventos = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter nomes dos eventos");
        });
    },
    eventosValidos() {
      for (let count = 0; count < this.eventos.length; count++) {
        if (
          !this.eventos[count].inicioString ||
          this.eventos[count].inicioString.length < 16
        ) {
          this.$notification.error(
            "É obrigatório o preenchimento de data e hora de início do evento"
          );
          return false;
        } else if (
          !this.eventos[count].fimString ||
          this.eventos[count].fimString.length < 16
        ) {
          this.$notification.error(
            "É obrigatório o preenchimento de data e hora de término do evento"
          );
          return false;
        } else if (
          this.datasEventos.indexOf(this.eventos[count].inicioString) > -1
        ) {
          this.$notification.error("Existe mais de um evento com a mesma data");
          return false;
        } else if (count === this.eventos.length - 1) {
          return true;
        } else if (count === 0) {
          this.datasEventos = [];
          this.datasEventos.push(this.eventos[count].inicioString);
        } else {
          this.datasEventos.push(this.eventos[count].inicioString);
        }
      }
    },
    showObs(evento) {
      evento.showObs = true;
      this.$forceUpdate();
    },
    changeTarefasSelecionadas() {
      let ids = [];
      this.eventos.map((evt) => {
        if (evt.tarefasEvento.length > 0) {
          evt.tarefasEvento.map((tar) => {
            ids.push(tar.municipioTarefaId);
          });
        }
      });

      this.tarefas = [];
      this.todasAsTarefas.forEach((tarefa) => {
        if (!ids.includes(tarefa.municipioTarefaId)) {
          this.tarefas.push(tarefa);
        }
      });
    },
  },
  created() {
    this.loadCity();
  },
};
</script>

<style lang="scss">
@import "./../style.scss";
</style>
